
import Vue from 'vue';
import Toast from './index.vue'
import { ToastConfig } from '@/interface/ComponentsInterface'

let instance: any = null
function getInstance() {
    if (instance) {
        return instance
    }
    const ToastConstructor = Vue.extend(Toast)
    instance = new ToastConstructor()
    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)
    return instance
}
export async function ToastBox(config: ToastConfig) {
    const _instance = getInstance()
    _instance.visible = false
    await Vue.nextTick()
    if (typeof (config) === 'string' || typeof (config) === 'number') {
        _instance.message = config
        _instance.visible = true
        return
    }
    _instance.message = config.message
    if (config.time) {
        _instance.time = config.time
    }
    _instance.visible = true
}
const ToastPlugin = {
    install(_Vue: any) {
        _Vue.prototype.$toast = ToastBox
    },
}

export default ToastPlugin
